// @flow
import { UPDATE_META } from '../constants/action_types'

export type MetaType = {
    name: string,
    version: string,
    user: {},
}

const initialState = {
    name: 'er2_ficus',
    // The server will override this in the meta data that comes from the config file.
    version: '',
    user: false,
}

export default function meta(state = initialState, action) {
    switch (action.type) {
    case UPDATE_META:
        return {
            ...state,
            name: action.name,
            version: action.version,
            user: action.user,
        }

    default:
        return state
    }
}
